import { Injectable, ViewChild } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({ providedIn: 'root' })
export class LoaderService {
    private events = new BehaviorSubject<boolean>(false);

    public showLoader() {
        this.events.next(true);
    }

    public hideLoader() {
        this.events.next(false);
    }

    public get spinnerStatusChanged() : Observable<boolean> {
        return this.events.asObservable();
    }
}